import { useEffect, useState } from 'react'

import { IFilter, Logic, Operator } from 'core-components/types'
import { thirdPartyLogsApi, ThirdPartyTypeCrudCacheKeys } from 'onboarding/api/thirdPartyLogsApi'

interface IProps {
  partnerId: string
  requestId?: number
  isDisabled?: boolean
}

/**
 * @param partnerId
 * @param requestId - requestId is parentRequest.EntryId || request.EntryId
 * @param isDisabled
 */
export const useThirdPartyType = ({ partnerId, requestId, isDisabled }: IProps) => {
  const [thirdPartyType, setThirdPartyType] = useState<string | null>(null)
  const [isThirdPartyTypeLoading, setThirdPartyTypeLoading] = useState(true)

  useEffect(() => {
    let unsubscribe
    if (!isDisabled) {
      const crud = thirdPartyLogsApi.getTypeCrud(
        requestId
          ? ThirdPartyTypeCrudCacheKeys.PartnerOrRequest
          : ThirdPartyTypeCrudCacheKeys.PartnerOnly
      )
      const fetchThirdPartyType = async () => {
        const filters: IFilter[] = [
          { field: 'PartnerId', operator: Operator.EQUAL, value: partnerId },
        ]
        if (requestId) {
          filters.push({ field: 'RequestId', operator: Operator.EQUAL, value: requestId })
        }
        crud.setFilter({
          logic: Logic.AND,
          filters,
        })
        setThirdPartyTypeLoading(true)
        const result = await crud.fetch({ skipHierarchyFilter: true })
        setThirdPartyType(result.items[0] ?? null)
        setThirdPartyTypeLoading(false)
      }

      fetchThirdPartyType()

      unsubscribe = crud.subscribe('change', fetchThirdPartyType)
    }

    return unsubscribe
  }, [partnerId, requestId, isDisabled])

  return { thirdPartyType, isThirdPartyTypeLoading }
}
